/**
 * Hook to fetch earn history (points history)
 */
import { useInfiniteQuery } from '@tanstack/react-query';
import { HttpBackend } from '../Services/Http/HttpBackend';
import { EarnModelHistory, EarnModelHistoryQueryRequest, createEarnModelHistory } from '../Model/Engagement/Earn/EarnModelHistory';

const PAGE_SIZE = 20;

type FetchEarnHistoryParams = {
  pageParam?: number;
  startDateTime?: Date;
  endDateTime?: Date;
  allowInChallenge?: boolean;
};

async function fetchEarnHistory({
  pageParam = 0,
  startDateTime,
  endDateTime,
  allowInChallenge,
}: FetchEarnHistoryParams): Promise<EarnModelHistory[]> {
  const params: EarnModelHistoryQueryRequest = {
    page: pageParam,
    size: PAGE_SIZE,
    sort: 'request.eventDateTime,DESC',
    startDateTime,
    endDateTime,
    allowInChallenge,
  };
  const json = await HttpBackend.get(`/coach-program/engagement/earn/history`, params);
  return (json ?? []).map((e: any) => createEarnModelHistory(e));
}

export type UseEarnHistoryOptions = {
  startDateTime?: Date;
  endDateTime?: Date;
  allowInChallenge?: boolean;
};

export function useEarnHistory(options: UseEarnHistoryOptions = {}) {
  const { startDateTime, endDateTime, allowInChallenge } = options;

  return useInfiniteQuery({
    queryKey: ['earnHistory', startDateTime, endDateTime, allowInChallenge],
    queryFn: ({ pageParam }) =>
      fetchEarnHistory({ pageParam, startDateTime, endDateTime, allowInChallenge }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => (lastPage.length >= PAGE_SIZE ? allPages.length : undefined),
  });
}
